<router-outlet /> 
@if(!isCustomReportRouteEnabled) {
<app-progress-spinner />
}
<app-cookie-consent></app-cookie-consent>
